module.exports = __webpack_public_path__ + "static/media/home-bg.a088d4aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-bg.jpg
// module id = 1236
// module chunks = 0